import { Component } from '@angular/core';

@Component({
  selector: 'app-two-split-legal-section',
  standalone: true,
  imports: [],
  templateUrl: './two-split-legal-section.component.html',
  styleUrl: './two-split-legal-section.component.scss'
})
export class TwoSplitLegalSectionComponent {

}
